export var DnsproveStatusCode;
(function (DnsproveStatusCode) {
    DnsproveStatusCode[DnsproveStatusCode["IDNS_QUERY_ERROR_GENERAL"] = 0] = "IDNS_QUERY_ERROR_GENERAL";
})(DnsproveStatusCode || (DnsproveStatusCode = {}));
export class CodedError extends Error {
    constructor(message, code, codeString) {
        super(message);
        this.code = code;
        this.codeString = codeString;
    }
}
